export const sleep = async (t) => new Promise(resolve => {
    setTimeout(resolve, t);
});
export const getname = (str) => {
    const reg = /\b([\w\d]+)(\.[\w\d]+)?$/;
    const result = str.match(reg);
    if (!result || !result[1]) {
        return 'unknown';
    }
    return result[1];
};
